import {
  DeltafaktorBaustein,
  TaasTarifrisikoschluesselAllSparten,
} from '@ps20-frontend/frontend-models';
import { Deltafaktoren, Deltafaktoren as DeltafaktorenBff } from '@ps20/bff-models';
import {
  AngebotsId,
  DeltafaktorenChanged,
  GlobalActions,
  GlobalPut,
} from '@ps20-frontend/shop-integration-redux';
import { call, put } from 'redux-saga/effects';

export function* setDeltafaktorenIfAvailable(
  deltafaktoren: DeltafaktorenBff,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
): any {
  if (deltafaktoren && Object.keys(deltafaktoren.bausteinDeltafaktoren).length > 0) {
    const payload: DeltafaktorenChanged = {
      deltafaktoren: {
        deltafaktoren: mapDeltafaktorenToArray(deltafaktoren.bausteinDeltafaktoren),
        isInRange: !deltafaktoren.grenzwertUeberschritten,
      },
    };

    yield put(new GlobalActions().deltafaktorenChanged(payload));
  }
  yield put(
    new GlobalActions().tarifgenerationDataReceived({
      vorgangsId: deltafaktoren?.vorgangsId,
      salesProdukt: deltafaktoren?.salesProdukt,
    }),
  );
}

function mapDeltafaktorenToArray(deltafaktorenKeyValue: {
  [key: string]: number;
}): Array<DeltafaktorBaustein> {
  return Object.keys(deltafaktorenKeyValue).map((key: string) => ({
    baustein: key as TaasTarifrisikoschluesselAllSparten,
    faktor: deltafaktorenKeyValue[key],
  }));
}

export function* handleDeltafaktorenOutOfRange(
  deltafaktorenResponse: Deltafaktoren,
  { appId, angebotsId }: AngebotsId,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
): any {
  if (deltafaktorenResponse?.grenzwertUeberschritten) {
    const globalPut = GlobalPut.getInstance();
    yield call(globalPut.put, new GlobalActions().deltafaktorOutOfRange(appId, angebotsId));
  }
}
